<script>
import OrdersApi from "@/services/orders-api";
import ItemsApi from "@/services/items-api";

export default {

    props: {

        exchangeOrders:{
          type: Boolean,
          default: false,
        },
        selectedModeId: Number,
        status:{
          type:Array,
          default:null
        },
        pointingState:Number,
        selectedPaymentMethode:Number,
        isCurrent:{
          type:Boolean,
          default:false
        },
        isMinimumOrders:{
          type:Boolean,
          default:false
        },
        phoneNumber:{
          type:String,
          default:null
        },
        deliveryNote:{
          type:String,
          default:null
        },
        orderNumber:{
          type:String,
          default:null
        },
        start:{
          type:String,
          default:null
        },
        end:{
          type:String,
          default:null
        },
    },
    
    data () {
        return {
        

        orderListFields: [
          { key:"submissionDate", label: "Date", sortable: false, tdClass:"font-weight-bold align-middle"},
          { key:"ref", label: "Référence",thClass:"",tdClass:" align-middle" },
          { key:"itemsCount", label: "Articles",   thClass:"text-right", tdClass:"font-size-14 text-right align-middle"},
          { key:"total", label: "Total TTC",   thClass:"text-right", tdClass:"text-right font-size-14 align-middle",},
          { key:"status", label: "Etat de livraison",  thClass:"text-right ", tdClass:"text-right  align-middle"},
          { key:"converteToOrder", label:"",tdClass:"text-right align-middle"},
          { key:"actions", label:"",tdClass:"text-center align-middle"},
          ],

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},

        ordersList: [],
        isTableLoading: false,
        selectedOrderId:null,
        selectedOrderLine:null,
        showImageModal:null,
        itemImage:null,
        selectedItemRef:null,
        selectedItemTitle:null,
        }

    },
    mounted () {
      this.getOrders();
    },




methods: {

  openImageModal(line){
    this.itemImage = null ;
    this.findImageByItem(line.itemId)
    this.selectedItemRef = line.ref
    this.selectedItemTitle = line.itemTitle
    this.showImageModal = true;
  },

  findImageByItem(itemId) {
        ItemsApi.findImageByItem(itemId ).then((result)=>{
          if(result){
            this.itemImage = result ;
          }
        });
      },

   statusToLabel(order) {
      const status = order.status;
      const isDeliveryFailed = order.isDeliveryFailed;

      if (status === 6 && isDeliveryFailed) {
        return 'canceledDeliveryFailed';
      }

      switch(status) {
        case 0: return 'draft';
        case 1: return 'pending';
        case 2: return 'calledCustomer';
        case 3: return 'beingPrepared';
        case 4: return 'beingDelivered';
        case 5: return 'delivered';
        case 6: return 'canceled';
        default: return '_';
      }
    },

    deliveryStatusToLabel(deliveryStatus,status){
      if(status!=2 && status!=3){
        return '_'
      }
      switch(deliveryStatus){
        case 0 : return 'notDelivered';
        case 1 : return 'partiallyDelivered';
        case 2 : return 'delivered';
        default: return 'notDelivered'
      }
    },

    deliveryStatusToColor(deliveryStatus,status){
      if(status!=2 && status!=3){
        return 'black'
      }
      switch(deliveryStatus){
        case 0 : return 'danger';
        case 1 : return 'info';
        case 2 : return 'success';
        default: return 'danger'
      }
    },

    statusToColor(order) {

      const status = order.status;
      const isDeliveryFailed = order.isDeliveryFailed;

      if (status === 6 && isDeliveryFailed) {
        return 'dark';
      }

      switch(status) {
        case 0: return 'light';
        case 1: return 'danger';
        case 2: return 'danger';
        case 3: return  'warning'; 
        case 4: return 'success';
        case 5: return 'light';
        case 6: return 'secondary';
        default: return 'secondary';
      }
    },

    getOrders() {

      this.isTableLoading = true
      const orderRequest = {
        page: this.pagemodel.currentPage,
        perPage: this.pagemodel.perPage,
        showDrafts: this.showDrafts,
        exchangeOrders: this.exchangeOrders,
        status: this.status,
        pointingState: this.pointingState,
        start: this.start,
        end: this.end,
        current: this.isCurrent,
        channel: this.channel,
        selectedModeId: this.selectedModeId,
        phoneNumber: this.phoneNumber,
        deliveryNote: this.deliveryNote,
        orderNumber: this.orderNumber,
        }
          
          OrdersApi.getOrders(orderRequest)
      .then(orders => {
        if(orders){
          this.ordersList = orders.list
          this.pagemodel.totalRows = orders.total;
          this.pagemodel.currentPage = orders.page;
          this.pagemodel.perPage = orders.pageSize;
          this.pagemodel.pageSize = orders.pageSize;

          this.isTableLoading = false ;

        }

      })
      .finally(() => {
        this.isTableLoading = false ;
      })
    },
},

  watch: {

    orderNumber: function(){
      this.getOrders()
    },
    selectedPaymentMethode: function(){
      this.getOrders()
    },
    selectedModeId: function(){
      this.getOrders()
    },
    phoneNumber: function(){
      this.getOrders()
    },
    deliveryNote: function(){
      this.getOrders()
    },
    status: function(){
      this.getOrders()
    },
    pointingState: function(){
      this.getOrders()
    },
    end: function(){
      if((this.end  && this.start) || (!this.end  && !this.start) ){
        this.getOrders()
      }
      
    },
    start: function(){
      if((this.end && this.start) || (!this.end  && !this.start)  ){
        this.getOrders()

      }
    },


},
  };


</script>


<template>
<div>
  <div class="row">
  </div>
  <div class="table-responsive pt-3" style=" min-height: 20em;">
        <b-table 
        :busy="isTableLoading"
        :striped="true"

        :small="false"
        :hover="true"

        :items="ordersList"
        :fields="orderListFields"

        :perPage="pagemodel.perPage"
        class="table  "
        style="min-width: 1400px">
        <template v-slot:table-busy>
        <div class="text-center my-2">
            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
        </template>
   
      <template v-slot:head(submissionDate)>
        {{ $t("ordersMenu.list.header.submissionDate") }} 
      </template>

      <template v-slot:head(ref)>
        {{ $t("ordersMenu.list.header.ref") }} 
      </template>

      <template v-slot:head(itemsCount)>
        {{ $t("ordersMenu.list.header.itemsCount") }} 
      </template>

      <template v-slot:head(total)>
        {{ $t("ordersMenu.list.header.total") }} 
      </template>

      <template v-slot:head(totalWithTaxes)>
        {{ $t("ordersMenu.list.header.totalWithTaxes") }} 
      </template>

      <template v-slot:head(status)>
        {{ $t("ordersMenu.list.header.orderStatus") }} 
      </template>

      <template v-slot:head(submissionUserName)>
        Utilisateur
      </template>

      <template v-slot:cell(actions)="{item}"> 
        <router-link :to="{ path: '/commandes/commande', query: { orderId: item.id }}">
          <b-button v-if="item.linesCount" title="Ouvrir"  size="sm"   variant="outline-dark" >
                <i class="far fa-file-alt  font-size-16 align-middle mr-0 mr-xl-2"></i>
                <span class="d-none font-weight-bold d-xl-inline">{{ $t("ordersMenu.list.button")}}</span>
          </b-button> 
        </router-link>

      </template>

      <template v-slot:cell(status)="{item}">
        <h5 class="m-0"><b-badge href="#" class="font-weight-bold" :variant="statusToColor(item)">{{$t("ordersMenu.statusLabel."+statusToLabel(item))}}</b-badge></h5>
      </template>

      <template v-slot:cell(total)="{item}">
        <div>{{ item.total }}</div>
        <div v-if="item.giftCardCode && item.giftCardAmount">
          <span  class="text-danger font-size-12 text-uppercase font-weight-normal"><i>NàP {{ item.finalAmountToPay }}</i></span>
          
      </div>

      </template>

      <template v-slot:cell(submissionUserName)="{value}">
        {{value}}
      </template>

      <template v-slot:cell(deliveryStatus)="{item,value}">  
        <h5><b-badge href="#" :variant="deliveryStatusToColor(value,item.status)">{{$t("ordersMenu.statusLabel."+deliveryStatusToLabel(value,item.status))}}</b-badge></h5>
      </template>

        <template v-slot:cell(ref)="{item,value}">
        <span :class="item.status ==0 ? 'text-danger' : ''">{{value}}</span>
        </template>
        
        <template v-slot:cell(submissionDate)="{item,value}">
            <div v-if="item.submissionDate">{{value}}</div>
            <div v-if="item.processingDate"><span class="text-muted font-size-12 font-weight-normal"><i>Traitée le {{item.processingDate}}</i></span></div>
        </template>

        </b-table>
        <span v-if="!isTableLoading && ordersList && !ordersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('ordersMenu.list.empty')}} </span>
    </div>

    <!-- Pagination -->
    <div class="row pt-3 mb-sm-0">
        <div class="col-sm-8">
            <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                <b-form-select @input="getOrders()"  v-model="pagemodel.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t('pagination.from')}}</span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{$t('pagination.lines')}}</span></div>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getOrders()" :disabled="isTableLoading" ></b-pagination>
                </ul>
            </div>
        </div>
    </div> 
    <!-- Fin Pagination  -->



    <b-modal  v-if="this.itemImage" v-model="showImageModal "  
            :title="'Image Article ' + selectedItemTitle + '-' + selectedItemRef " 
            hide-footer 
            centered 
            title-class="text-primary text-uppercase"
            title-tag="h5"
            header-close-variant="danger"
            size="md">

            <div class="text-center">
              <img :src="this.itemImage" class="img-fluid" /> 
            </div>
    </b-modal>
</div>
</template>                 
               

<style scoped>

.card {
  border: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-header {
  background-color: #f8f9fa;
  cursor: pointer;
}

.line-item {
  background-color: #fff;
  transition: box-shadow 0.3s ease;
}

.line-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.fa-chevron-up {
  transition: transform 0.3s ease;
}

.collapsed .fa-chevron-up {
  transform: rotate(180deg);
}
</style>